import { Card, CardContent, CardHeader, Grid, Typography } from '@mui/material';
import { theme } from 'theme';
import { jbColors } from 'theme/jbColors';
import ContextIcon from 'assets/icons/Context.svg?react';
import CustomCircularProgress from 'components/common/CustomCircularProgress';
import { ProductServiceDetailsResponse } from 'pco-product-service-internal-consumer';

const styles = {
  container: {
    paddingLeft: theme.spacing(2),
  },
  divider: {
    flex: 1,
    borderColor: jbColors.core.reflexBlue[40],
  },
  icon: {
    marginTop: theme.spacing(2),
  },
  cardHeader: {
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(1),
  },
  card: {
    maxWidth: '90%',
  },
  spinner: {
    marginTop: theme.spacing(1),
  },
};

type Props = {
  item: ProductServiceDetailsResponse;
  isLoading: boolean;
};
export const DefinedContext = ({ item, isLoading }: Props) => {
  const { account = 'N/A', portfolio = 'N/A', profile = 'N/A', investmentAmount = 'N/A', bookingCenter = 'N/A' } = item;

  // to handle null value
  const investmentToShow = investmentAmount ? investmentAmount : 'N/A';

  return (
    <Card data-testid="defined-context-component" sx={styles.card} square>
      <Grid container sx={styles.container}>
        <ContextIcon style={styles.icon} />
        <CardHeader title={'DEFINED CONTEXT'} titleTypographyProps={{ variant: 'subtitle1' }} sx={styles.cardHeader} />
      </Grid>
      <CardContent>
        {isLoading ? (
          <Grid
            id={'defined-context-circular-progress'}
            data-testid={'defined-context-circular-progress'}
            sx={styles.spinner}
          >
            <CustomCircularProgress size={30} />
          </Grid>
        ) : (
          <Grid container direction={'row'}>
            <Grid item container direction={'column'} xs={2}>
              <Grid item>
                <Typography variant={'caption'}>Account</Typography>
              </Grid>
              <Grid item>
                <Typography>{account}</Typography>
              </Grid>
            </Grid>
            <Grid item container direction={'column'} xs={2}>
              <Grid item>
                <Typography variant={'caption'}>Portfolio</Typography>
              </Grid>
              <Grid item>
                <Typography>{portfolio}</Typography>
              </Grid>
            </Grid>
            <Grid item container direction={'column'} xs={2}>
              <Grid item>
                <Typography variant={'caption'}>Profile</Typography>
              </Grid>
              <Grid item>
                <Typography>{profile}</Typography>
              </Grid>
            </Grid>
            <Grid item container direction={'column'} xs={2}>
              <Grid item>
                <Typography variant={'caption'}>Investment</Typography>
              </Grid>
              <Grid item>
                <Typography>{investmentToShow}</Typography>
              </Grid>
            </Grid>
            <Grid item container direction={'column'} xs={2}>
              <Grid item>
                <Typography variant={'caption'}>Booking center</Typography>
              </Grid>
              <Grid item>
                <Typography>{bookingCenter}</Typography>
              </Grid>
            </Grid>
          </Grid>
        )}
      </CardContent>
    </Card>
  );
};
